(($, Drupal) => {
  Drupal.behaviors.select = {
    attach: function attach(context) {
      // Select2 is added as webform module extension
    },
  };

  Drupal.behaviors.whitePaperSubmit = {
    attach: function attach(context) {
      $('.webform-confirmation', context).each((index, element) => {
        const $element = $(element);
        if ($element.attr('data-ga-event-category') && $element.attr('data-ga-event-label')) {
          gtag('event', 'Form submission', {
            event_category: $element.attr('data-ga-event-category'),
            event_label: $element.attr('data-ga-event-label'),
            transport_type: 'beacon',
          });
        }
      });
    },
  };
})(jQuery, Drupal);
